import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Text from './Text';
const SmallCaps = props => /*#__PURE__*/React.createElement(Text, _extends({
  textTransform: "uppercase",
  fontWeight: "bold"
}, props));
export default SmallCaps;